import { useContext } from "react";

import { StepOne, StepThree, StepTwo } from "../Steps";

import { GenericDataFormContext } from "../shared/contexts/GenericDataForm";
import { WizardDataFormProvider } from "./contexts/WizardDataForm";

import { PreLiquidationStep } from "../shared/interfaces";
import { StepOneFormProvider } from "../Steps/StepOne/contexts/StepOneForm";
import { StepTwoFormProvider } from "../Steps/StepTwo/contexts/StepTwoForm";
import { StepThreeFormProvider } from "../Steps/StepThree/contexts/StepThreeForm";
import { LoadSavedPreliquidation } from "../components/LoadSavedPreliquidation";


export const WizardPreLiquidation = () => {
  const { currentStep, loadingSavedPreliquidation } = useContext(GenericDataFormContext);

  const getStepComponent = () => {
    switch (currentStep) {
      case PreLiquidationStep.ONE:
        return <StepOne />;
      case PreLiquidationStep.TWO:
        return <StepTwo />;
      case PreLiquidationStep.THREE:
        return <StepThree />;
      default:
        break;
    }
  };

  return (
    <WizardDataFormProvider>
      <StepOneFormProvider>
        <StepTwoFormProvider>
          <StepThreeFormProvider>
            {
              loadingSavedPreliquidation ? <LoadSavedPreliquidation/> : getStepComponent() 
            }
          </StepThreeFormProvider>
        </StepTwoFormProvider>
      </StepOneFormProvider>
    </WizardDataFormProvider>
  )
}

